import { render, staticRenderFns } from "./createtPurchasePlan.vue?vue&type=template&id=417145c6&scoped=true&"
import script from "./createtPurchasePlan.vue?vue&type=script&lang=js&"
export * from "./createtPurchasePlan.vue?vue&type=script&lang=js&"
import style0 from "./createtPurchasePlan.vue?vue&type=style&index=0&id=417145c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417145c6",
  null
  
)

component.options.__file = "createtPurchasePlan.vue"
export default component.exports